var $ = require('jquery');

web = window.web = window.web || {};

web.ContentLoader = module.exports = function(options) {
    var t = this;
    t.instanceState = 'contructed';
    t.defaults = {

    }

    t.$elm = null;
    t.options = $.extend({}, t.defaults, options);

    t.SELECTOR_PREFIX = ".js_contentLoader-";

    this.xhr = null;

};

web.ContentLoader.prototype = {
    init: function(){
        var t = this;

        t._bindEvents();
    },

    setSelectorPrefix: function(selectorPrefix){
        var t = this;

        t.SELECTOR_PREFIX = selectorPrefix;
    },

    _bindEvents: function(context){
        var t = this;

        if (typeof context == "undefined") var context = $("body");
        if (!(context instanceof jQuery)) var context = $(context);

        context.on("click", t.SELECTOR_PREFIX+"getContent", function(e){
            var $t = $(this);
            var contentUrl = $t.data("jsContentLoaderContentUrl");
            var contentWrapperSelector = $t.data("jsContentLoaderContentWrapperSelector");
            var appendSelector = $t.data("jsContentLoaderAppendSelector");

            t.getContent(contentUrl, contentWrapperSelector, null, null, function($content){
                t.appendContent(appendSelector, $content, context);
            }, null);

            e.preventDefault();
        });

        context.on("click", t.SELECTOR_PREFIX+"removeContent", function(e){
            var $t = $(this);
            var removeFromSelector = $t.data("jsContentLoaderRemoveFromSelector");

            t._removeContent(removeFromSelector, context);

            e.preventDefault();
        })

    },

    _removeContent: function(removeFromSelector, $context){
        var t = this;
        $(t).trigger({
            type: "beforeContentRemove",
            removeFromSelector: removeFromSelector,
            context: $context
        });

        if (typeof removeFromSelector != 'string') {
            $context.empty();
        } else {
            $context.find(removeFromSelector).empty();
        }

        $(t).trigger({
            type: "afterContentRemove",
            removeFromSelector: removeFromSelector,
            context: $context
        });

    },

    appendContent: function(appendSelector, $content, $context){
        var t = this;

        $(t).trigger({
            type: "beforeContentAppend",
            appendSelector: appendSelector,
            content: $content,
            context: $context
        });

        if (typeof appendSelector != 'string') {
            $context.append($content);
        } else {
            $context.find(appendSelector).append($content);
        }

        $(t).trigger({
            type: "afterContentAppend",
            appendSelector: appendSelector,
            content: $content,
            context: $context
        });
    },

    getContent: function(contentUrl, contentWrapperSelector, beforeSendCallback, completeCallback, successCallback, errorCallback) {
        var t = this;


        if (typeof beforeSendCallback != 'function') var beforeSendCallback = function(){};
        if (typeof completeCallback != 'function') var completeCallback = function(){};
        if (typeof successCallback != 'function') var successCallback = function(){};
        if (typeof errorCallback != 'function') var errorCallback = function(){};
        if (typeof contentWrapperSelector != 'string') var contentWrapperSelector = "body";

        this.xhr = $.ajax({
            url: contentUrl,
            beforeSend: function(){
                beforeSendCallback();
                $(t).trigger({
                    type: "xhrBeforeSend",
                    contentUrl:contentUrl,
                    contentWrapperSelector: contentWrapperSelector
                });
            },
            complete: function(){
                completeCallback();
                $(t).trigger({
                    type: "xhrComplete",
                    contentUrl:contentUrl,
                    contentWrapperSelector: contentWrapperSelector
                });
            },
            success: function(data){
                var $data = $(data);
                var found = $data.find(contentWrapperSelector);

                if ($data.hasClass(contentWrapperSelector.replace(".", ""))) {
                    found=0;
                }

                var out = null;

                if (!!found.length) {
                    out = found;
                } else {
                    out =  $data;
                }

                successCallback(out);

                $(t).trigger({
                    type: "xhrSuccess",
                    contentUrl:contentUrl,
                    contentWrapperSelector: contentWrapperSelector,
                    content: out
                });

            },
            error: function(xhr, status, error){
                errorCallback();
                $(t).trigger({
                    type: "xhrError",
                    contentUrl:contentUrl,
                    contentWrapperSelector: contentWrapperSelector
                });
            }
        });
    }


}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/ContentLoader.js